import React from "react";
import {ArrowUpward as UpArrow, ArrowDownward as DownArrow} from "@material-ui/icons";

const TableHeaderColumn = ({children, sort, sortName, className, onClick, ...rest}) => (
  <div
    className={`table-header-column ${className || ""}`}
    {...rest}
    onClick={() => {
      if (onClick) {
        onClick({[sortName]: sort ? (sort *= -1) : 1});
      }
    }}>
    <p style={{display: "inline-block", verticalAlign: "top"}}>{[children]}</p>
    {sort === 1 && <DownArrow />}
    {sort === -1 && <UpArrow />}
  </div>
);

export default TableHeaderColumn;



// WEBPACK FOOTER //
// ./src/components/Table/TableHeaderColumn/index.jsx